import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getMedia } from "../../services/clients";
import MediaTable from "../../components/Tables/MediaTable";

export const Media = () => {
  const { selectedClient } = useContext(AppContext);
  const [media, setMedia] = useState([]);

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        setMedia(await getMedia(selectedClient.public_id ?? selectedClient.id));
        console.log(media);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT: ", selectedClient);
    if (selectedClient) {
      fetchMedia();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div style={{ width: "100%" }}>
      <MediaTable media={media} />
    </div>
  );
};

export default Media;
